<div class="no-header-panel">
    <ng-container #fieldComponent></ng-container>
</div>